<template>
  <modal
    :header-text="$t('trafficSettings.header')"
    :hide-footer="true"
    @close="close"
  >
    <div :class="$style.container">
      <div :class="$style.settingRow">
        <span :class="$style.label">{{ $t('trafficSettings.controlTraffic') }}</span>
        <select
          v-model="trafficKind"
          :class="$style.select"
        >
          <option :value="0">
            {{ $t('trafficSettings.allTraffic') }}
          </option>
          <option :value="1">
            {{ $t('trafficSettings.externalOnly') }}
          </option>
          <option :value="2">
            {{ $t('trafficSettings.internalOnly') }}
          </option>
        </select>
      </div>

      <div :class="$style.settingRow">
        <label :class="$style.checkboxLabel">
          <input
            v-model="onlyBrowsers"
            type="checkbox"
          >
          <span>{{ $t('trafficSettings.browsersOnly') }}</span>
        </label>
      </div>

      <div :class="$style.settingRow">
        <span :class="$style.label">{{ $t('trafficSettings.ignoreTraffic') }}</span>

        <input
          v-model.number="ignoreTrafficLess"
          type="number"
          :class="$style.input"
        >

        <span :class="$style.bytesLabel">{{ $t('global.bytes') }}</span>
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';

  export default {
    components: {
      Modal,
    },

    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      trafficKind: {
        get() {
          return +this.data.trafficKind;
        },
        set(value) {
          this.updateSetting('trafficKind', value);
        },
      },

      onlyBrowsers: {
        get() {
          return this.data.onlyBrowsers;
        },
        set(value) {
          this.updateSetting('onlyBrowsers', value);
        },
      },

      ignoreTrafficLess: {
        get() {
          return this.data.ignoreTrafficLess;
        },
        set(value) {
          this.updateSetting('ignoreTrafficLess', value);
        },
      },
    },

    methods: {
      close() {
        this.$emit('close');
      },
      updateSetting(key, value) {
        this.$emit('update', key, value);
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    padding: 0 20px;
  }

  .settingRow {
    display: flex;
    align-items: center;
    margin: 15px 0;
    gap: 10px;
  }

  .label {
    min-width: 150px;
    font-size: 14px;
  }

  .select {
    padding: 5px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 2px;
    flex: 1;
  }

  .checkboxLabel {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }

  .input {
    padding: 5px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 100px;
  }

  .bytesLabel {
    font-size: 14px;
  }
</style>
